import React from 'react';
import ICellProps from '../ICellProps';
import {
  DatePicker,
  IDatePickerStrings,
  DayOfWeek,
} from 'office-ui-fabric-react';
import moment from 'moment';
import Readonly from '../Readonly';

interface IProps extends ICellProps {
  onChange: (value: string) => void;
  dataAttrQA: { [key: string]: string | number};
}


const DayPickerStrings: IDatePickerStrings = {
  months: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],

  shortMonths: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Июн',
    'Июл',
    'Авг',
    'Сен',
    'Окт',
    'Ноя',
    'Дек',
  ],

  days: [
    'Воскресенье',
    'Понеделик',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
  ],

  shortDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],

  isRequiredErrorMessage: 'Выберите дату',

  goToToday: 'Перейти к сегодня',
  prevMonthAriaLabel: 'Предыдущий месяц',
  nextMonthAriaLabel: 'Следующий месяц',
  prevYearAriaLabel: 'Следующий год',
  nextYearAriaLabel: 'Предыдущий год',
  closeButtonAriaLabel: 'Закрыть выбор даты',
};

const formatDate = (date?: Date | null) =>
  date ? moment(date).format('DD.MM.YYYY') : '';
const toDbDate = (date?: Date | null) =>
  date
    ? moment(date)
        .format('YYYY-MM-DD')
    : '';
const stringToDate = (dt?: string | null): Date | undefined =>
  dt && dt.length > 0 ? new Date(dt) : undefined;

const DateCtrl: React.FC<IProps> = (props: IProps) => {
  return props.readonly ? (
    <Readonly {...props.dataAttrQA}>{formatDate(props.value)}</Readonly>
  ) : (
    <DatePicker
      label={undefined}
      firstDayOfWeek={DayOfWeek.Monday}
      strings={DayPickerStrings}
      onSelectDate={(date?: Date | null) => props.onChange(toDbDate(date))}
      value={stringToDate(props.value)}
      textField={{
        styles: {
          fieldGroup: {
            border: 'none',
          },
        },
      }}
      placeholder={'-'}
      formatDate={formatDate}
      aria-required={false}
      {...props.dataAttrQA}
    />
  );
};

export default DateCtrl;
